export default {
  // Title and description
  title: "User Shared Canvas",
  sharedCanvas: "shared canvas",
  userUid: "User uid",
  welcomeText: "Welcome to",

  // System description
  systemDescription: "A one-stop investigation and control platform for combating new types of virtual currency-related crimes, centered on on-chain transaction tracing and anonymous identity penetration.",

  // Feature list
  feature1: "Industry-leading address label database",
  feature2: "Empowering advanced security response capabilities",
  feature3: "Multi-dimensional case quality and efficiency enhancement",
  feature4: "One-click access to evidence collection targets",

  // Input field
  enterAccessPassword: "Please enter access password",

  // Time related
  expirationTime: "Expiration time",

  // Buttons
  confirm: "Confirm",

  // Error messages
  canvasExpired:
    "This canvas share has expired or sharing has been disabled, temporarily inaccessible",
};
